export default "__VITE_ASSET__Tn$W8hRf__"